package com.eladfinish.bible.contest.extensions

/**
 * Developed by
 * @author Elad Finish
 */

fun List<String>.getItemsPrefixedByNumbers(itemsToBold: List<Int> = emptyList()): List<String> {
    this.toMutableList().apply {
        itemsToBold.forEach { this[it] = "*" + this[it] + "*" }
    }

    return this.mapIndexed { index, str -> index.plus(1).toString().plus(". ").plus(str) }
}